<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center">Zbieraj punkty i wymieniaj je na zniżki! </span>
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/collect-points.jpg" />

  <div class="or-mb-20-px or-text-lg">Grasz, organizujesz, zapraszasz znajomych i zdobywasz osiągnięcia? Super!</div>
  <div class="or-mb-20-px or-head-md">Za każdą z tych akcji zbierasz punkty, które widzisz na swoim profilu.</div>
  <div class="or-mb-20-px or-text-lg">
    A najlepsze? W przyszłości wymienisz je na nagrody i zniżki u naszych partnerów! Dołącz do gry i zbieraj punkty już
    teraz!
  </div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
